export default __webpack_public_path__ + "static/fa-regular-400-bb58e57c48a3e911f15fa834ff00d44a.woff";